// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__1n2iN","tab":"Tabs_tab__1dSrS","tabActive":"Tabs_tabActive__Mjo1f"};